import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Button } from '@ipc/ipc-components';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/tables/ListTable';
import {
  getColumns,
  getData,
  getIsLoading,
  getCheckedRows,
} from '../redux/selectors/EdiRfidAuditRequestExecutionsSelectors';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import EdiRfidAuditExecutionDelete from '../delete/containers/EdiRfidAuditExecutionDelete';
import EdiRfidAuditDelete from '../../request/delete/containers/EdiRfidAuditDelete';
import { EdiRfidAuditRequestExecutionListContainerStyle } from './EdiRfidAuditRequestExecutionListContainer.styles';

class EdiRfidAuditRequestExecutionListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteConfirmModal: false,
      showRequestDeleteModal: false,
    };
  }

  componentDidMount() {
    this.refreshExecutionList();
  }

  refreshExecutionList = () => {
    this.props.tableLoadData(
      { tableId: TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTIONS.id },
      this.props.appContext.appContext,
      { requestId: this.props.row.original.requestId },
    );
  }

  showIndividualRequestDeleteFormModal = () => {
    this.setState({
      showRequestDeleteModal: true,
    });
  }

  hideIndividualRequestDeleteFormModal = () => {
    this.setState({
      showRequestDeleteModal: false,
    });
  }

  showDeleteFormModal = () => {
    this.setState({
      showDeleteConfirmModal: true,
    });
  }

  hideDeleteFormModal = () => {
    this.setState({
      showDeleteConfirmModal: false,
    });
  }

  deleteAuditRequest = () => {
    this.setState({
      showRequestDeleteModal: true,
    });
  }

  deleteAuditExecution = () => {
    this.setState({
      showDeleteConfirmModal: true,
    });
  }

  render() {
    const {
      showDeleteConfirmModal,
      showRequestDeleteModal,
    } = this.state;
    return (
      <EdiRfidAuditRequestExecutionListContainerStyle>
        <Button className="action-buttons" onClick={this.deleteAuditRequest}>
          EDI-RFID Audit Request Individual Delete
        </Button>
        <Button
          className={`action-buttons primary-button-${!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}`}
          disabled={!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}
          onClick={this.deleteAuditExecution}
        >
          EDI-RFID AUDIT EXECUTIONS BULK DELETE
        </Button>
        <ListTable
          listId={TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTIONS.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
          keyField="executionId"
          selectCheckbox
          pagination
        />
        {showDeleteConfirmModal && (
          <EdiRfidAuditExecutionDelete
            closeDialog={this.hideDeleteFormModal}
            openDialog={this.showDeleteFormModal}
            row={this.props.checkedRows}
            refreshExecutionList={this.refreshExecutionList}
          />
        )}
        {showRequestDeleteModal && (
          <EdiRfidAuditDelete
            closeDialog={this.hideIndividualRequestDeleteFormModal}
            openDialog={this.showIndividualRequestDeleteFormModal}
            row={this.props.row.original}
          />
        )}
      </EdiRfidAuditRequestExecutionListContainerStyle>
    );
  }
}

EdiRfidAuditRequestExecutionListContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  tableLoadData: PropTypes.func,
  row: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.string),
  checkedRows: PropTypes.arrayOf(PropTypes.object),
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    checkedRows: getCheckedRows(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EdiRfidAuditRequestExecutionListContainer);
